import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalProps,
} from '@chakra-ui/react';
import { themeVariables } from '@meteraprotocol/sdk/ui/theme.js';

export const TransactionModal = ({
  children,
  minHeight,
  maxWidth,
  p = '',
  ...rest
}: ModalProps & { minHeight?: string; maxWidth?: string; p?: string }) => (
  <Modal isCentered {...rest}>
    <ModalOverlay bg="#171717B3" />
    <ModalContent
      background={themeVariables.background.purple200}
      minHeight={minHeight || '23rem'}
      maxWidth={maxWidth || '40%'}
      borderRadius={'1.25rem'}
      border={`1px solid ${themeVariables.cards.stroke}`}
      sx={{ backdropFilter: 'blur(60px)' }}
    >
      <ModalBody p={p || 0}>{children}</ModalBody>
    </ModalContent>
  </Modal>
);
